import first from 'lodash/first';
import { useMemo } from 'react';
import { renewalAppHasStatuses } from '../utils/license-utils';
import { LicenseDetails } from './license-details-modules/license-details';
import { LicenseStatusSwitcher } from './license-details-modules/license-status-switcher';
import { RenewalStatusSwitcher } from './license-details-modules/renewal-status-switcher';
import { SupplementalQuestionsAccordion } from './supplemental-questions-accordion';

export function ExpandedLicenseInfo(props) {
  const {
    index,
    license,
    licenseConfig,
    refresh,
    supplementalQuestionsConfig,
  } = props;

  /**
   * Legacy comment.
   * At the moment, it seems like there will only be one renewal application at a time,
   * so we can always pick the first element in the array.
   */
  const mostRecentLicenseRenewal = useMemo(
    () => first(license?.renewals),
    [license]
  );

  const shouldShowRenewalsDropdown = useMemo(
    () => renewalAppHasStatuses(mostRecentLicenseRenewal),
    [mostRecentLicenseRenewal]
  );

  return (
    <div>
      <LicenseStatusSwitcher
        index={index}
        license={license}
        shouldShowRenewalsDropdown={shouldShowRenewalsDropdown}
        refresh={refresh}
      />

      <RenewalStatusSwitcher
        index={index}
        renewalDict={mostRecentLicenseRenewal}
        showDropdown={shouldShowRenewalsDropdown}
      />

      {licenseConfig.map((el, idx) => (
        <LicenseDetails
          key={`${license.licenseId}-license-details-${idx}`}
          config={el}
          data={license}
        />
      ))}

      <SupplementalQuestionsAccordion
        license={license}
        config={supplementalQuestionsConfig}
      />
    </div>
  );
}
